export enum DetectionThresholdType {
  insect = 'insect',
  sensor = 'sensor'
}
